export const resSuccess = {
	success: {
		code: 100,
		message: 'OK',
	},
};
// 40x
export const resError = {
	error: {
		code: 400,
		message: 'Bad Request: `a parameter` is required.',
	},
};
export const res401 = {
	error: {
		code: 401,
		message: 'Unauthorized: Token Authentication Required',
	},
};
export const res403 = {
	error: {
		code: 403,
		message: 'Unauthorized: Token Authentication Required',
	},
};

export const resWarning = {
	warning: {
		code: 1660,
		message: 'Warning',
	},
};

export const resAborted = {
	data: null,
	status: -1,
	config: {},
	statusText: '',
	xhrStatus: 'abort',
};

export const resConfig = {
	config: {
		method: 'GET',
		transformRequest: [],
		transformResponse: [],
		url: 'https://localhost:3000',
		params: null,
		headers: {
			Accept: 'application/json,text/plain,*/*',
			'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
			Auth: '',
		},
		jsonpCallbackParam: 'callback',
		data: '',
	},
	data: {
		payLoad: null,
		client_version: null,
		session_token: null,
	},
	status: null,
	statusText: null,
	xhrStatus: 'complete',
};
